import { render, staticRenderFns } from "./PvctapeSticker.vue?vue&type=template&id=79fbd68e&scoped=true&"
import script from "./PvctapeSticker.vue?vue&type=script&lang=js&"
export * from "./PvctapeSticker.vue?vue&type=script&lang=js&"
import style0 from "./PvctapeSticker.vue?vue&type=style&index=0&id=79fbd68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbd68e",
  null
  
)

component.options.__file = "PvctapeSticker.vue"
export default component.exports